import balloonStyles from '../../../cleaning/balloon/Balloon.module.css';
import styles from '../../../cleaning/window/content/Content.module.css';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faClock, faCommentDots,
    faMapMarkerAlt, faMinus, faPlusCircle, faSave, faUserAlt
} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {selectDrivesInRoutes} from "../../route/routeSlice";
import _ from "lodash";
import {CRM_BASE_URL} from "../../../../app/crm";

const OnsiteContent = ({drive, onAddToRoute, onDriveUpdate}) => {

    const [commentIsOpen, setCommentIsOpen] = useState(false);
    const [newComment, setNewComment] = useState(drive.logisticNote);
    const drivesInRoutes = useSelector(selectDrivesInRoutes);
    const driveHasInRoute = _.find(drivesInRoutes, (item) => item.drive.id === drive.id);
    const displayDrive = driveHasInRoute?.drive || drive;

    useEffect(() => {
        setCommentIsOpen(false);
        setNewComment(drive.logisticNote);
    }, [drive.id]);

    const commentForm = (
        <div className={balloonStyles.CommentForm} key={drive.id}>
            <label>Заметка логиста</label>
            <Form.Control as={"textarea"}
                          onInput={(e) => {
                              setNewComment(e.target.value);
                          }}
                          defaultValue={newComment} style={{height: '80px'}}/>
            <Row style={{"marginTop": '5px'}}>
                <Col md={7}></Col>
                <Col md={2}>
                    <Button variant={"danger"} onClick={() => {
                        setNewComment(drive.logisticNote);
                        setCommentIsOpen(false);
                    }} size={'sm'}>
                        <FontAwesomeIcon icon={faMinus}/>
                    </Button>
                </Col>
                <Col md={2}>
                    <Button variant={"success"} onClick={() => {
                        onDriveUpdate(drive, {logisticNote: newComment});
                        setCommentIsOpen(false);
                        setNewComment(newComment);
                    }} size={'sm'}>
                        <FontAwesomeIcon icon={faSave}/>
                    </Button>
                </Col>
            </Row>
        </div>
    );

    return (
        <div className={styles.WindowWrap}>
            <div>
                <Row>
                    <Col md={12}>
                        <span className={balloonStyles.OrderNumber}>
                            <a target="_blank"
                               rel="noreferrer"
                               href={CRM_BASE_URL + '/onsite-drycleaning/update/' + drive.order.id}>
                                {drive.orderNumber}
                            </a>
                        </span>
                    </Col>
                    <Col md={12}>
                        <span className={classNames({
                            [balloonStyles.Status]: true,
                            [displayDrive.statusLabel]: true
                        })}>
                            {displayDrive.statusAtString}
                        </span>
                    </Col>
                    <Col md={12}>
                        <span className={balloonStyles.Time}>
                            <FontAwesomeIcon icon={faClock}/> {displayDrive.time}
                        </span>
                    </Col>
                    <Col md={12}>
                        <span className={balloonStyles.Address}>
                            <FontAwesomeIcon icon={faMapMarkerAlt}/> {drive.addressData.expandedAddress}
                        </span>
                    </Col>
                    {displayDrive.onsiteDrycleanerName ? <Col md={12}>
                        <span className={balloonStyles.Cleaner}>
                            Мастер — {displayDrive.onsiteDrycleanerName}
                        </span>
                    </Col> : null}
                    {drive.order?.client ? <Col md={12}>
                        <Row>
                            <Col md={8}>
                                <span className={balloonStyles.User}>
                                    <FontAwesomeIcon icon={faUserAlt}/>
                                    <a target="_blank"
                                       rel="noreferrer"
                                       href={CRM_BASE_URL + '/admin/client/view?id=' + drive.order.client.id}>
                                        &nbsp;{drive.order.client.name}
                                    </a>
                                </span>
                            </Col>
                            <Col md={1}>
                                <div>
                                    <FontAwesomeIcon
                                        onClick={() => setCommentIsOpen(true)}
                                        className={balloonStyles.ActionIcon}
                                        icon={faCommentDots}/>
                                    {newComment ?
                                        <span
                                            onClick={() => setCommentIsOpen(true)}
                                            className={balloonStyles.CommentCounter}>1</span> : null}
                                </div>
                            </Col>
                            <Col md={1}>
                                <FontAwesomeIcon
                                    className={balloonStyles.ActionIcon}
                                    onClick={() => {
                                        if (typeof driveHasInRoute === "undefined") {
                                            onAddToRoute(drive);
                                        }
                                    }}
                                    icon={faPlusCircle}/>
                            </Col>
                        </Row>
                    </Col> : null}
                </Row>
                {commentIsOpen ? commentForm : null}
            </div>
        </div>
    );
};

export default OnsiteContent;
